__turbopack_context__.v({
  "buttonFieldRp": "klantenkaart-overmkg-module-scss-module__E6PlWG__buttonFieldRp",
  "buttonWissen": "klantenkaart-overmkg-module-scss-module__E6PlWG__buttonWissen",
  "buttonZoek": "klantenkaart-overmkg-module-scss-module__E6PlWG__buttonZoek",
  "clusterContainer": "klantenkaart-overmkg-module-scss-module__E6PlWG__clusterContainer",
  "clusterImage": "klantenkaart-overmkg-module-scss-module__E6PlWG__clusterImage",
  "clusterText": "klantenkaart-overmkg-module-scss-module__E6PlWG__clusterText",
  "headerKaartContainer": "klantenkaart-overmkg-module-scss-module__E6PlWG__headerKaartContainer",
  "inputFieldRow": "klantenkaart-overmkg-module-scss-module__E6PlWG__inputFieldRow",
  "inputFieldRp": "klantenkaart-overmkg-module-scss-module__E6PlWG__inputFieldRp",
  "inputTextRow": "klantenkaart-overmkg-module-scss-module__E6PlWG__inputTextRow",
  "inputsFieldsRow": "klantenkaart-overmkg-module-scss-module__E6PlWG__inputsFieldsRow",
  "introKaartContainer": "klantenkaart-overmkg-module-scss-module__E6PlWG__introKaartContainer",
  "kaartGrootte": "klantenkaart-overmkg-module-scss-module__E6PlWG__kaartGrootte",
  "kaartcontainer": "klantenkaart-overmkg-module-scss-module__E6PlWG__kaartcontainer",
  "klantenlijstContainer": "klantenkaart-overmkg-module-scss-module__E6PlWG__klantenlijstContainer",
  "klantenlijstKolom": "klantenkaart-overmkg-module-scss-module__E6PlWG__klantenlijstKolom",
  "linkstyling": "klantenkaart-overmkg-module-scss-module__E6PlWG__linkstyling",
  "plaatsInput": "klantenkaart-overmkg-module-scss-module__E6PlWG__plaatsInput",
  "selectField": "klantenkaart-overmkg-module-scss-module__E6PlWG__selectField",
  "typeFilterItem": "klantenkaart-overmkg-module-scss-module__E6PlWG__typeFilterItem",
  "typeFilterLabel": "klantenkaart-overmkg-module-scss-module__E6PlWG__typeFilterLabel",
  "typeFilterRow": "klantenkaart-overmkg-module-scss-module__E6PlWG__typeFilterRow",
});
